// Port of api/fuel/app/classes/controller/api/monty/users/insights.php
import Constants from 'offline/constants'
import Insights from 'offline/insights'
import { resolveOwner } from 'offline/api/monty'
import F from 'offline/filter/constants'

export default function(params) {
	if (!params.slug && params.name) params = Object.assign({}, params, { slug: params.name })

	// Resolve owner by slug/name, not by insight-specific id (game_id/player_id)
	var ownerParams = Object.assign({}, params)
	delete ownerParams.id
	var owner = resolveOwner(ownerParams, F.OWNER_USER)
	if (!owner) {
		return Promise.reject({ error: 'Owner not found in offline database', offline: true })
	}

	return Promise.resolve(Insights.generate(
		Constants.TYPE_USER,
		owner,
		params.section || false,
		params.insight || false,
		params.detail || false,
		params.filter || {},
		params
	))
}
